import axios, { AxiosRequestConfig } from 'axios';
import querystring from 'query-string';

import { IRequest } from './interface';

/**
 * 创建独立的 axios 实例，专门用于第三方 API 请求
 * 不使用全局拦截器，避免携带平台的认证信息
 */
const externalApiInstance = axios.create({
  timeout: 30000, // 30秒超时
  withCredentials: true,
});

externalApiInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

externalApiInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    return Promise.reject(error);
  },
);

function request(config: AxiosRequestConfig) {
  return externalApiInstance(config)
    .then((res: any = {}) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

export function postJSONExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'post',
    url,
    data,
    ...config,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function postFormExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'post',
    url,
    data: querystring.stringify(data),
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

export function getExernal<T>(url: string, params?: Record<string, any>, config?: IRequest): Promise<T> {
  if (params) {
    url = `${url}?${querystring.stringify(params)}`;
  }
  return request({
    method: 'get',
    url,
    ...config,
  });
}

export function patchJSONExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'patch',
    url,
    data,
    ...config,
    headers: {
      'Content-Type': 'application/merge-patch+json', // 资源的部分
    },
  });
}

export function patchJsonPatchExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'patch',
    url,
    data,
    ...config,
    headers: {
      'Content-Type': 'application/json-patch+json', // 必须是操作数组
    },
  });
}

export function patchFormExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'patch',
    url,
    data: querystring.stringify(data),
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

export function putJSONExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'put',
    url,
    data,
    ...config,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function delJSONExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'delete',
    url,
    data,
    ...config,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function putFormExernal<T>(url: string, data?: object, config?: IRequest): Promise<T> {
  return request({
    method: 'put',
    url,
    data: querystring.stringify(data),
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

export function deleteResExernal<T>(url: string, params?: Record<string, any>, config?: IRequest): Promise<T> {
  if (params) {
    url = `${url}?${querystring.stringify(params)}`;
  }
  return request({
    method: 'delete',
    url,
    ...config,
  });
}
